// extracted by mini-css-extract-plugin
export default {"createBtn":"CompanyList_createBtn__nvmys"};